import spacings from '@/assets/constants/spacings';
import styled from 'styled-components';

export const Dot = styled.div<{ color: string; }>`
    height: 16px;
    width: 16px;
    border-radius: 8px;
    background-color: ${props => props.color};
    margin-right: ${spacings.xxxs}px;
`;